"use strict";

var novicell = novicell || {};
var dgv = dgv || {};


dgv.imageParallax = dgv.imageParallax || function () {

    function init() {
        imageParallax();
        scrollAnimations();
    }

    // TV product slider
    function imageParallax() {
        var image_parallax = document.querySelectorAll('.js-image-parallax');

        if ( image_parallax ) {
            for (var i = 0; i < image_parallax.length; i++) {
                parallaxScroll(image_parallax[i]);
            }
        }

        window.addEventListener('scroll', function() {
            if ( image_parallax ) {
                for (var i = 0; i < image_parallax.length; i++) {
                    parallaxScroll(image_parallax[i]);
                }
            }
        });

        function parallaxScroll(element) {
            var element_speed = element.getAttribute('data-parallax-speed');

            if (isInViewport(element)) {
                if ( !element.classList.contains('show') ) {
                    element.classList.add('show');
                }

                var speed = (element.getBoundingClientRect().top / 10) * element_speed;

                element.style.transform = 'translateY('+ speed +'px)';
            }
        }

        function isInViewport(el) {
            var rect = el.getBoundingClientRect(),
                windowHeight = (window.innerHeight || document.documentElement.clientHeight),
                windowWidth = (window.innerWidth || document.documentElement.clientWidth);

            // Partially in view
            var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0),
                horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

            return (vertInView && horInView);
        }
    }

    function scrollAnimations() {
        var element = document.querySelectorAll('.js-scroll-animation');

        if ( element ) {
            for (var i = 0; i < element.length; i++) { 
                makeWatcher(element[i]);
            }
        }

        function viewportWatcher() {
            if (!this.isInViewport) {
                return;
            } else if (this.isFullyInViewport) {
                animation(this.watchItem);
            }
        }

        function animation(element) {
            if ( !element.classList.contains('show') ) {
                element.classList.add('show');
            }
        }

        function makeWatcher( element ) {
            var element_height  = element.clientHeight / 2,
                watcher         = scrollMonitor.create( element, -element_height );
            watcher.stateChange(viewportWatcher);
            viewportWatcher.call( watcher );
        }
    }

    return {
        init: init,
        imageParallax : imageParallax
    };

}();